import cx from 'classnames/dedupe';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import React, { Component } from 'react';

import ReplaceableComponents from '~/components/higher-order/ReplaceableComponents';

const SweetAlertContainer = styled.div``;

const mapStateToProps = (state, props) => {
  const stateResolver = props.stateResolver || ((state) => state);

  return {
    alert: stateResolver(state).get('currentAlert'),
  };
};

const components = {
  SweetAlertContainer,
};

@ReplaceableComponents(components)
@connect(mapStateToProps)
class SweetAlertApp extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    const { alert } = this.props;

    document.body.className = cx(document.body.className, {
      'modal-open': alert != null,
    });
  }

  componentWillUnmount() {
    document.body.className = cx(document.body.className, {
      'modal-open': false,
    });
  }

  render() {
    const { alert } = this.props;
    const { SweetAlertContainer } = this.props.components;

    return <SweetAlertContainer>{alert}</SweetAlertContainer>;
  }
}

export default SweetAlertApp;
